// credits: https://stackoverflow.com/a/57047786
function isRelative(testUrl) {
    return new URL(document.baseURI).origin === new URL(testUrl, document.baseURI).origin;
}
export function markers(baseUrl, markers) {
    return markers?.map(marker => {
        if (marker.image && isRelative(marker.image)) {
            if (marker.image[0] === "/") {
                marker.image = baseUrl + marker.image.substring(1);
            }
            else {
                marker.image = baseUrl + marker.image;
            }
        }
        if (marker.imageLayer && isRelative(marker.imageLayer)) {
            if (marker.imageLayer[0] === "/") {
                marker.imageLayer = baseUrl + marker.imageLayer.substring(1);
            }
            else {
                marker.imageLayer = baseUrl + marker.imageLayer;
            }
        }
        if (marker.videoLayer && isRelative(marker.videoLayer)) {
            if (marker.videoLayer[0] === "/") {
                marker.videoLayer = baseUrl + marker.videoLayer.substring(1);
            }
            else {
                marker.videoLayer = baseUrl + marker.videoLayer;
            }
        }
        return marker;
    });
}
